import { jsx as _jsx } from "react/jsx-runtime";
import { formatISO, parseISO } from 'date-fns';
import { Calendar, } from '@awaze/design-system.components.calendar';
/**
 * A component for selecting a date within a form using `formHooks`.
 *
 * Default calendar styles are baked in but can be overridden by passing in any overriding props to `calendarProps`
 */
export const Datepicker = ({ formHooks, name, calendarProps, }) => {
    const onDaySelected = (date) => {
        const stringValue = formatISO(date, { representation: 'date' });
        formHooks.setValue(name, stringValue);
    };
    const calendarFinalProps = {
        baseDate: new Date(),
        duration: 1,
        ...calendarProps,
    };
    const currentValue = formHooks.watch(name);
    const currentValueAsDate = currentValue ? parseISO(currentValue) : null;
    return (_jsx(Calendar, { onDaySelected: onDaySelected, ...calendarFinalProps, ...(currentValueAsDate && { baseDate: currentValueAsDate }), startDate: currentValueAsDate }));
};
//# sourceMappingURL=datepicker.js.map